import React from "react"
import Styles from "./layout2.module.scss"
import Navi from "./navi"

import Footer from "./footer"
const layout2 = props => {
  return (
    <>
      <div className={Styles.con}>
        <Navi />

        <div className={Styles.main}>
          <h1>{props.title}</h1>
          <article>{props.children}</article>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default layout2
